/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MedicalPrescriptionsListAliases {
  BARCODE_COMPONENT = 'barcode-component',
  BUTTON_CONFIRMATION_PRESCRIPTIONS_LIST = 'button-confirmation-prescriptions-list',
  DECK_MEDICAL_PRESCRIPTIONS_LIST_CARD = 'deck-medical-prescriptions-list-card',
  FETCH_MEDICAL_PRESCRIPTIONS_LIST_CARD = 'fetch-medical-prescriptions-list-card',
  FIELD_INPUT_CONFIRMATION_PRESCRIPTIONS_LIST = 'field-input-confirmation-prescriptions-list',
  FORM_PRESCRIPTIONS_LIST = 'form-prescriptions-list',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  INPUT_CONFIRMATION_PRESCRIPTIONS_LIST = 'input-confirmation-prescriptions-list',
  LAYOUT_CONFIRMATION_PRESCRIPTIONS_LIST = 'layout-confirmation-prescriptions-list',
  LAYOUT_MEDICAL_PRESCRIPTION_LIST = 'layout-medical-prescription-list',
  MEDIA_QUERY_MEDICAL_PRESCRIPTIONS_LIST_CARD = 'media-query-medical-prescriptions-list-card',
  MEDICAL_PRESCRIPTIONS_CARD = 'medical-prescriptions-card',
  PANEL_BUTTON_CONFIRMATION_PRESCRIPTIONS_LIST = 'panel-button-confirmation-prescriptions-list',
  PANEL_CONFIRMATION_PRESCRIPTIONS_LIST = 'panel-confirmation-prescriptions-list',
  PANEL_INPUT_PRESCRIPTIONS_LIST = 'panel-input-prescriptions-list',
  PANEL_MEDICAL_PRESCRIPTIONS_LIST_CARD = 'panel-medical-prescriptions-list-card',
  ROOT_LAYOUT = 'root-layout',
}
export { MedicalPrescriptionsListAliases };
